import { requestWithToken } from '../../../utilities/request';

/**
 * 健康診断取得API
 * 指定した作業員に対する労務安全項目情報（健康診断）を取得する
 * GET /api/private/ccus/companies/:company_id/workers/:id/medical_examination
 * @param {number}companyId: 会社ID
 * @param {number}workerId: 作業員ID
 */
const fetchMedicalExamination = (companyId, workerId) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/ccus/companies/${companyId}/workers/${workerId}/medical_examination`,
  });
};

/**
 * 健康診断登録・更新API
 * 作業員に対する労務安全項目情報（健康診断）を登録または更新する
 * POST /api/private/ccus/companies/:company_id/workers/:id/medical_examination
 * @param {number}companyId: 会社ID
 * @param {number}workerId: 作業員ID
 * @param {object}param
 */
const updateMedicalExamination = (companyId, workerId, param) => {
  return requestWithToken({
    method: 'POST',
    url: `/api/private/ccus/companies/${companyId}/workers/${workerId}/medical_examination`,
    data: param,
  });
};

const MedicalExaminationApi = {
  fetchMedicalExamination,
  updateMedicalExamination,
};

export default MedicalExaminationApi;



// WEBPACK FOOTER //
// ./src/services/workers/medicalExamination/MedicalExaminationApi.js